<script setup lang="ts">
import './assets/style.scss'
import { useModel } from './../model/model.ts'
import { VIcons, VPreloader } from '@/shared/ui'
import { ProgramCabinetChart } from '@/entities/Schedule'
import { AdminCommandsSendSchedule } from '@/features/Cabinet'

const props = defineProps({
  scheduleId: {
    type: Number,
    required: true,
  },
  scheduleSync: {
    type: Number,
    required: true,
  },
  objectId: {
    type: Number,
    required: true,
  },
})

const { data, scheduleData, loadData } = useModel()

const { isPending } = loadData(props.scheduleId)
</script>

<template>
  <div class="schedule-item" v-if="!isPending && data">
    <div class="schedule-item__link">
      <RouterLink target="_blank" :to="`/schedules/${props.scheduleId}/programs`">
        {{ data.name }} <VIcons type="arrow_outward" />
      </RouterLink>
    </div>

    <div class="schedule-item__items">
      <ProgramCabinetChart v-for="(item, index) in scheduleData" :data="item" :key="index" />
    </div>

    <div v-if="!scheduleSync" class="schedule-item__sync">
      {{ $t('itf.not_synchro') }}

      <AdminCommandsSendSchedule :cabinet-id="objectId">
        <VBtn color="default" density="comfortable" variant="tonal">
          {{ $t('itf.submit') }}
        </VBtn>
      </AdminCommandsSendSchedule>
    </div>
  </div>

  <VPreloader :wrapper-height="100" v-else />
</template>
